export default {"src":"/_next/static/media/norton.7132d967.svg","height":32,"width":59};